import {handleActions} from 'redux-actions'
import * as types from '../../constants/ActionTypes'

const reducers = {}
reducers[types.START_SESSION_FINISH] = {
	next (state, action) {
		if(action.error){
			return {display: true}
		}
		return {}
	},
	throw (state, action) {
		return {display: true}
	}
}

reducers[types.CLOSE_GRAB_SINGLE_WARNING] = {
	next (state, action) {
		return {}
	},
	throw (state, action) {
		return {}
	}
}



export default handleActions(reducers, {})
